import {
	ThreeBannersProducts,
	TrendingProducts,
} from "../components/Widgets/Banner";
import PopulerProduct from "../components/Widgets/PopulerProduct";
import ProductSlider from "../components/Widgets/ProductSlider";
import Title from "../components/Widgets/Title";
import { CustomComponentSettingsFunction } from "../settings";
import { popularProductsConfig } from "../settings/popularProducts";
import { productsSliderConfig } from "../settings/productsSlider";
import { threeBannerProductsConfig } from "../settings/threeBannerProducts";
import titleWidgetConfig from "../settings/titleWidget";
import { trendingProductsConfig } from "../settings/trendingProducts";

export const customPageWidgetName = "custom-page";

export const customWidgets: {
	name: string;
	key: string;
	comp: React.FC;
	customComponentSettings?: CustomComponentSettingsFunction;
}[] = [
	{
		name: "Title",
		key: "custom-title",
		comp: Title,
		customComponentSettings: titleWidgetConfig,
	},
	{
		name: "Products Slider",
		key: "custom-products-slider",
		comp: ProductSlider,
		customComponentSettings: productsSliderConfig,
	},
	{
		name: "Popular Products",
		key: "custom-popular-products",
		comp: PopulerProduct,
		customComponentSettings: popularProductsConfig,
	},
	{
		name: "Three Banner Products",
		key: "custom-three-banner-product",
		comp: ThreeBannersProducts,
		customComponentSettings: threeBannerProductsConfig,
	},
	{
		name: "Trending Products",
		key: "custom-trending-products",
		comp: TrendingProducts,
		customComponentSettings: trendingProductsConfig,
	},
	// {
	// 	name: "Custom Product Card",
	// 	key: "custom-product-card",
	// 	comp: () => (
	// 		<div
	// 			className="product-card"
	// 			style={{
	// 				maxWidth: "232px",
	// 				textAlign: "center",
	// 				border: "1px solid #ddd",
	// 				padding: "10px",
	// 				borderRadius: "4px",
	// 			}}
	// 			data-gjs-type="product-card">
	// 			<img
	// 				src="https://via.placeholder.com/150"
	// 				alt="Product Image"
	// 				style={{
	// 					width: "200px",
	// 					height: "200px",
	// 					borderRadius: "4px",
	// 				}}
	// 			/>
	// 			<h3
	// 				style={{
	// 					fontSize: "18px",
	// 					color: "#333",
	// 					margin: "10px 0",
	// 				}}>
	// 				Product Title
	// 			</h3>
	// 			<p
	// 				style={{
	// 					fontSize: "14px",
	// 					color: "#555",
	// 					margin: "0 0 10px",
	// 				}}>
	// 				$19.99
	// 			</p>
	// 		</div>
	// 	),
	// 	customComponentSettings: productCardConfig,
	// },
];

export default function () {
	return <></>;
}
